'use client';

import { useState, useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function WebsiteTermsDocument() {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [containerWidth, setContainerWidth] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.clientWidth - 32);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  return (
    <div className="flex flex-col w-full min-h-screen">
      <div className="h-19 shrink-0" />
      <div
        ref={containerRef}
        className="w-full max-w-4xl mx-auto px-4 py-6 flex flex-col items-center justify-center overflow-x-hidden"
      >
        <Document
          file="/pdf/web_policy_terms_en.pdf"
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          className="flex flex-col items-center gap-4 w-full"
          loading={
            <div className="text-white text-sm animate-pulse py-12">
              Loading document...
            </div>
          }
        >
          {Array.from(new Array(numPages), (_, index) => (
            <div key={`page_${index + 1}`} className="shadow-2xl rounded-sm overflow-hidden">
              <Page
                pageNumber={index + 1}
                width={containerWidth ? Math.min(containerWidth, 800) : undefined}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </div>
          ))}
        </Document>
      </div>
    </div>
  );
}